import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const authCookie = Cookies.get("@DAS_AUTH") || JSON.stringify({});

const INITIAL_STATE = {
  loginLoading: false,
  signUpLoading: false,
  signUpSuccess: false,
  token: null,
  user: null,
  loginError: null,
  signUpError: null,
  verifyLoading:false,
  verifyError: null,
  verifySuccess: false,

 forgotLoading:false,
 forgotError: null,
 forgotSuccess: false,
 resetLoading:false,
 resetError: null,
 resetSuccess: false,
  ...JSON.parse(authCookie),
};

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    loginStart: (state) => {
      return {
        ...state,
        loginLoading: true,
        loginError: null,
      };
    },
    loginSuccess: (state, { payload: { token, user } }) => {
      return {
        ...state,
        loginLoading: false,
        token,
        user,
      };
    },
    loginError: (state, { payload: { error } }) => {
      return {
        ...state,
        loginLoading: false,
        loginError: error,
      };
    },
    clearLogin: (state) => {
      return {
        ...state,
        loginError: null,
      };
    },
    signUpStart: (state) => {
      return {
        ...state,
        signUpLoading: true,
        signUpError: null,
      };
    },
    signUpSuccess: (state) => {
      return {
        ...state,
        signUpLoading: false,
        signUpSuccess: true,
      };
    },
    signUpError: (state, { payload: { error } }) => {
      return {
        ...state,
        signUpLoading: false,
        signUpError: error,
      };
    },
    clearSignUp: (state) => {
      return {
        ...state,
        signUpSuccess: false,
        signUpError: null,
      };
    },
    logOut: (state) => {
      return {
        ...state,
        token: null,
        user: null,
      };
    },
    verifyStart: (state) => {
      return {
        ...state,
        verifySuccess: false,
        verifyError: null,
      };
    },
    verifySuccess: (state) => {
      return {
        ...state,
        verifyLoading: false,
        verifySuccess: true,
      };
    },
    verifyError: (state, { payload: { error } }) => {
      return {
        ...state,
        verifyLoading: false,
        verifyError: error,
      };
    },
    //     verifyStart: (state) => {
    //   return {
    //     ...state,
    //     verifySuccess: false,
    //     verifyError: null,
    //   };
    // },
    // verifySuccess: (state) => {
    //   return {
    //     ...state,
    //     verifyLoading: false,
    //     verifySuccess: true,
    //   };
    // },
    // verifyError: (state, { payload: { error } }) => {
    //   return {
    //     ...state,
    //     verifyLoading: false,
    //     verifyError: error,
    //   };
    // },
    forgotStart: (state) => {
   
      return {
        ...state,
        forgotSuccess: false,
        forgotError: null,
      };
    },
    forgotSuccess: (state) => {
      return {
        ...state,
        forgotLoading: false,
        forgotSuccess: true,
      };
    },
    forgotError: (state, { payload: { error } }) => {
      return {
        ...state,
        forgotLoading: false,
        forgotError: error,
      };
    },

  

  resetStart: (state) => {
    return {
      ...state,
      resetSuccess: false,
      resetError: null,
    };
  },
  resetSuccess: (state) => {
    return {
      ...state,
      resetLoading: false,
      resetSuccess: true,
    };
  },
  resetError: (state, { payload: { error } }) => {
    return {
      ...state,
      resetLoading: false,
      resetError: error,
    };
  },
},

});

export const {
  loginStart,
  loginSuccess,
  loginError,
  clearLogin,
  signUpStart,
  signUpSuccess,
  signUpError,
  clearSignUp,
  logOut,
  verifyStart,
  verifyError,
  verifySuccess,
  forgotError,
  forgotSuccess,
  forgotStart,
  forgotLoading,

  resetError,
  resetSuccess,
  resetStart,
  resetLoading,
} = authSlice.actions;

export default authSlice.reducer;
